import React from 'react';
import { Button, ToolbarDivider } from '@cloudsam/ui';

/**
 * Account identity and the single entry point to channel-account management.
 * Role authorization belongs to each action in the manager and is enforced
 * again by DBAM; the dashboard toolbar does not impersonate another role.
 */
export default function ChannelsToolbarActions({ roleName, bindingsOpen, onOpenBindings }) {
    return (
        <>
            <span className="channels-login">Logged in: {roleName}</span>
            <ToolbarDivider />
            <Button
                variant="onDark"
                ghost
                active={bindingsOpen}
                onClick={onOpenBindings}
            >
                Bindings
            </Button>
        </>
    );
}
